// Antes do início: o escritório escolhe quais blocos do checklist esta OS terá (a visita de CFTV não precisa do bloco de cerca).
// Depois do check-in o checklist congela (regra da API).
import { useState } from 'react';
import { api } from '../../api';

export interface BlocoOs { bloco_id: string; nome: string; sistema: string | null; categoria: string | null; itens: number; equipamentos: number | null; incluido: boolean; motivo: string }
const MOTIVO: Record<string, string> = { padrao: '', fora_dos_sistemas: 'fora dos sistemas desta visita', incluido_pelo_operador: 'incluído à mão', tirado_pelo_operador: 'tirado à mão' };

export function BlocosChecklist<T>({ osId, blocos, sistemas, podeEditar, aoMudar }: { osId: string; blocos: BlocoOs[]; sistemas: string[] | null; podeEditar: boolean; aoMudar: (ficha: T) => void }) {
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);
  if (!blocos.length) return null;

  async function alternar(b: BlocoOs) {
    setErro(null); setSalvando(true);
    // ajuste do operador = o que difere do padrão da visita
    let incluir = blocos.filter((x) => x.motivo === 'incluido_pelo_operador').map((x) => x.bloco_id);
    let excluir = blocos.filter((x) => x.motivo === 'tirado_pelo_operador').map((x) => x.bloco_id);
    if (b.motivo === 'incluido_pelo_operador') incluir = incluir.filter((x) => x !== b.bloco_id);
    else if (b.motivo === 'tirado_pelo_operador') excluir = excluir.filter((x) => x !== b.bloco_id);
    else if (b.motivo === 'padrao') excluir = [...excluir, b.bloco_id];
    else incluir = [...incluir, b.bloco_id];
    try { aoMudar(await api<T>(`/os/${osId}/checklist/blocos`, { metodo: 'PUT', corpo: { incluir, excluir } })); }
    catch (e) { setErro((e as Error).message); } finally { setSalvando(false); }
  }

  return (
    <section className="secao">
      <h2>Blocos do checklist desta OS</h2>
      <p className="nota">{sistemas?.length ? 'Esta visita é do plano de preventiva: entram os blocos gerais e os dos sistemas da visita. ' : ''}Antes do check-in dá para tirar ou pôr bloco; no check-in o checklist congela.</p>
      {erro && <p className="alerta" role="alert">{erro}</p>}
      <div className="chips">
        {blocos.map((b) => (
          <button key={b.bloco_id} type="button" className={`chip${b.incluido ? ' ativo' : ''}`} disabled={!podeEditar || salvando} onClick={() => alternar(b)}
            title={[MOTIVO[b.motivo], `${b.itens} item(ns)`, b.equipamentos != null ? `${b.equipamentos} equipamento(s) no parque` : ''].filter(Boolean).join(' · ')}>
            {b.incluido ? '✓ ' : ''}{b.nome}{b.motivo.endsWith('operador') ? ' *' : ''}
          </button>
        ))}
      </div>
      <small className="ajuda">* mudado à mão nesta OS.</small>
    </section>
  );
}
